import { Accordion } from 'components/DesignSystems/Accordion/Accordion';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { MicrosoftTemplate, CustomTemplate } from 'types/template';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { ScrollableList } from 'components/DesignSystems/ScrollableList';
import { useFetchMicrosoftTemplates } from 'hooks/useFetchMicrosoftTemplates';
import { useFetchCustomTemplates } from 'hooks/useFetchCustomTemplates';

interface Props {
  handleTemplateSelect: (template: MicrosoftTemplate | CustomTemplate) => void;
}

export default function SelectExistingTemplates({
  handleTemplateSelect,
}: Props) {
  // NOTE (5/7/2025): Commenting this out, as the teams_integration repo hasn't been updated
  // const [showMicrosoftTemplates, setShowMicrosoftTemplates] = useState(false);
  const [showMicrosoftTemplates, setShowMicrosoftTemplates] = useState(true);
  const tenantId = useSelector((state: any) => state.app.tenantId);

  const { data: teamsTemplates = [], isLoading: isLoadingMicrosoft } =
    useFetchMicrosoftTemplates();
  const { data: customTemplates = [], isLoading: isLoadingCustom } =
    useFetchCustomTemplates(tenantId);

  if (isLoadingMicrosoft && showMicrosoftTemplates) {
    return <div>Loading Microsoft templates...</div>;
  }

  if (isLoadingCustom && !showMicrosoftTemplates) {
    return <div>Loading custom templates...</div>;
  }

  const templatesToShow = showMicrosoftTemplates
    ? teamsTemplates
    : customTemplates;

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex justify-content-end mb-3">
      {/* // NOTE (5/7/2025): Commenting this out, as the teams_integration repo hasn't been updated */}
        {/* <StylishNewButton
          className="button--secondary"
          onClick={() => setShowMicrosoftTemplates(!showMicrosoftTemplates)}
        >
          {showMicrosoftTemplates
            ? 'Show Custom Templates'
            : 'Show Microsoft Templates'}{' '}
          (
          {showMicrosoftTemplates
            ? customTemplates.length
            : teamsTemplates.length}
          )
        </StylishNewButton> */}
      </div>
      <div className="d-flex flex-column h-100 w-100">
        <ScrollableList emptyMessage="No templates available">
          {templatesToShow.map(
            (template: MicrosoftTemplate | CustomTemplate, i: number) => (
              <div key={template.label + i} className="mb-3">
                <Accordion
                  header={() => (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="d-flex flex-column">
                        <span className="fs-5">{template.label}</span>
                        <span className="text-muted small">
                          {!showMicrosoftTemplates
                            ? (template as CustomTemplate).description
                            : ''}
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {!showMicrosoftTemplates && (
                          <span className="text-muted">
                            {(template as CustomTemplate).channels?.length || 0}{' '}
                            channels
                          </span>
                        )}
                        <SharedIcon
                          iconName="more_vert"
                          bold
                          classes="cursor-default"
                        />
                      </div>
                    </div>
                  )}
                  eventKey={
                    showMicrosoftTemplates
                      ? (template as MicrosoftTemplate).value
                      : (template as CustomTemplate).label
                  }
                >
                  <div className="d-flex flex-column">
                    <div className="accordion-details" />
                    <div className="d-flex flex-row justify-content-end me-4 pb-2">
                      <StylishNewButton
                        onClick={() => handleTemplateSelect(template)}
                        className="button--primary"
                      >
                        Use This Template
                      </StylishNewButton>
                    </div>
                  </div>
                </Accordion>
              </div>
            )
          )}
        </ScrollableList>
      </div>
    </div>
  );
}
